import { findFirstNonEmptyString } from "@product/scmp-sdk";
import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import { ImageGallery } from "~/components/image-gallery";
import type { articleImageGalleryContent$key } from "~/queries/__generated__/articleImageGalleryContent.graphql";

type Props = {
  children?: ReactNode;
  reference: articleImageGalleryContent$key;
};

export const ArticleImageGallery: FunctionComponent<Props> = ({
  children,
  reference: reference_,
}) => {
  const content = useFragment(
    graphql`
      fragment articleImageGalleryContent on Content {
        entityId
        urlAlias
        shortUrl
        headline
        socialHeadline
      }
    `,
    reference_,
  );

  const title = findFirstNonEmptyString(content.socialHeadline, content.headline);

  return (
    <ImageGallery
      relativeUrl={content.urlAlias}
      shortUrl={content.shortUrl ?? undefined}
      title={title}
      utm={{
        campaign: content.entityId,
        medium: "image_gallery",
      }}
    >
      {children}
    </ImageGallery>
  );
};

ArticleImageGallery.displayName = "ArticleImageGallery";
